import { render } from "./jobAnalysiss.vue?vue&type=template&id=28a7ea8e&scoped=true&ts=true&lang=pug"
import script from "./jobAnalysiss.vue?vue&type=script&lang=ts"
export * from "./jobAnalysiss.vue?vue&type=script&lang=ts"

import "./jobAnalysiss.vue?vue&type=style&index=0&id=28a7ea8e&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a7ea8e"]])

export default __exports__